// extracted by mini-css-extract-plugin
module.exports = {"container":"aa1254b386--container--k62Jt","desktop":"aa1254b386--desktop--wKA5P","tablet":"aa1254b386--tablet--U21Xg","phone":"aa1254b386--phone--TXHGD"};